import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { FacebookIcon, GoogleIcon } from './icons'
import crmServices from '../wsclient/'
import Typo from './CustomTypo';
import Button from './ButtonCustom';
import t from '../utils/translateUtil';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { GoogleLogin } from 'react-google-login';
import { navigate } from '../../portal.router.config'
import { domainName, portal_config } from '../../portal.config';
import crmservices from '../wsclient/';
import { getData, getLanguage } from '../utils/common';

const styles = theme => ({
    marginTop05: {
        marginTop: theme.spacing(1),
    },
    marginTop: {
        marginTop: theme.spacing(2),
    },
    topContent: {
        padding: theme.spacing(3),
        marginTop: theme.spacing(4),
    },
});

class SocialComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            language: getLanguage(),
        }
        this.FBLoginCallback = this.FBLoginCallback.bind(this);
        this.GGLoginCallback = this.GGLoginCallback.bind(this);
    }

    async FBLoginCallback(result) {
        this.props.onShowLoading(true);
        console.log('FBLoginCallback result=', result)
        if (!result.error) {
            var loginResult = await crmServices.contacts.authenticateFB({ challenge: result.id, remember_me: true });
            if (loginResult.code === 'OK') {
                this.props.onShowLoading(false);
                navigate('/home');
            } else if (loginResult.code === 'INVALID_LOGIN') {
                var registerResult = await crmServices.contacts.registerByFB({ ...result, fbID: result.id, language_code: this.state.language });
                if (registerResult.code === 'OK') {
                    this.props.onShowLoading(false);
                    navigate('/home');
                } else {
                    this.props.showAlert('ERROR', t('INVALID_PHONE_LOGIN'))
                }
            } else {
                //console.log('loginResult.code=',loginResult.code)
                this.props.showAlert("ERROR", t('EXCEPTION_PROCESS'), t('ERROR'))
            }
        }
        else {
            // this.props.showAlert('ERROR', t('EXCEPTION_PROCESS'))
        }
    }
    async GGLoginCallback(result) {
        try {
            if (result.googleId) {
                this.props.onShowLoading(true);
                var loginResult = await crmservices.contacts.authenticateGoogle({ challenge: result.googleId, remember_me: true });
                //console.log("AAAAAAAAAAAAA loginResult:", loginResult);
                if (loginResult.code === 'OK') {
                    this.props.onShowLoading(false);
                    navigate('/home');
                } else if (loginResult.code === 'INVALID_LOGIN') {
                    var registerResult = await crmServices.contacts.registerByGoogle({ first_name: result.profileObj.givenName, last_name: result.profileObj.familyName, googleId: result.googleId, language_code: this.state.language });
                    if (registerResult.code === 'OK') {
                        this.props.onShowLoading(false);
                        navigate('/home');
                    } else {
                        this.props.showAlert('ERROR', t('INVALID_PHONE_LOGIN'))
                    }
                } else {
                    this.props.showAlert('ERROR', t('EXCEPTION_PROCESS'))
                }
                this.props.onShowLoading(false);
            }
            else {
                // this.props.showAlert("ERROR", t('EXCEPTION_PROCESS'), t('ERROR'))
            }
        } catch (error) {
            console.log("GGLoginCallback exception:", error);
        }
    }


    render() {
        const { classes, t, auth_support } = this.props;
        console.log('auth_support===',auth_support)
        var fb_app_id = auth_support.facebook&&auth_support.fb_app_id?auth_support.fb_app_id: ''
        var google_app_id = auth_support.google&&auth_support.google_app_id?auth_support.google_app_id: ''
        return (
            <Grid xs={12} item container>
                < Grid xs={12} item container justify='center' className={classes.topContent}>
                    <Grid item xs={4} sm={4} md={3} lg={4} className={classes.marginTop05}>
                        <hr />
                    </Grid>
                    <Grid item container xs={4} sm={4} md={6} lg={4} justify='center' >
                        <Typo color='label' variant='body2' center>{t('or_sign_in_with')}</Typo>
                    </Grid>
                    <Grid item xs={4} sm={4} md={3} lg={4} className={classes.marginTop05}>
                        <hr />
                    </Grid>
                </Grid>

                <Grid xs={12} item container justify='center' className={classes.marginTop05}>
                    {auth_support && auth_support.facebook ? <Grid item container xs={6} sm={6}>
                        <FacebookLogin
                            appId={fb_app_id}
                            fields="id,name,email,first_name,last_name"
                            callback={this.FBLoginCallback}
                            render={renderProps => (
                                <Button fullWidth round={false} color="onPrimary" size='xs' onClick={renderProps.onClick}><FacebookIcon className={classes.marginTop} /></Button>)}
                        />
                    </Grid> : null}
                    {auth_support && auth_support.google ? <Grid item container xs={6} sm={6}>
                        <GoogleLogin
                            clientId={google_app_id}
                            render={renderProps => (
                                <Button round={false} fullWidth color="onPrimary" size='xs' onClick={renderProps.onClick} disabled={renderProps.disabled}><GoogleIcon className={classes.marginTop} /></Button>
                            )}
                            onSuccess={this.GGLoginCallback}
                            onFailure={this.GGLoginCallback}
                            cookiePolicy={'single_host_origin'}
                        />
                    </Grid> : null}
                </Grid>
            </Grid>
        );
    }
}
export default withStyles(styles)(withTranslation()(SocialComponent));